/**
 * Passe de la topbar desktop à la topbar mobile.
 *
 * @param {string} topbarSelector L'ID de la topbar.
 * @param {string} topbarItemsSelector Le sélecteur CSS des éléments de la topbar.
 * @param {string} mobileClassname Le nom de la classe en mode mobile.
 * @param {string} desktopClassname Le nom de la classe en mode desktop.
 * @param {string} mobileContainerSelector L'ID du container de la topbar en mode mobile.
 */
const topbarMobile = (
    topbarSelector,
    topbarItemsSelector,
    mobileClassname,
    desktopClassname,
    mobileContainerSelector
) => {
    const topbar = document.querySelector(topbarSelector);

    if (topbar.className === desktopClassname) {
        const topbarItems = topbar.querySelectorAll(topbarItemsSelector);
        const topbarMobileContainer = document.querySelector(
            mobileContainerSelector
        );

        topbar.className = mobileClassname;
        // If the given child is a reference to an existing node in the document, appendChild() moves
        // it from its current position to the new position.
        // https://developer.mozilla.org/en-US/docs/Web/API/Node/appendChild
        // On commence par déplacer la topbar dans le container mobile
        topbarMobileContainer.appendChild(topbar);
        // Ensuite on ajoute les <li></li> avec la classe "menu-item" en dessous du menu mobile
        topbarItems.forEach((item) => {
            const link = item.querySelector('a');
            // On ajuste les classes de l'élément
            if (link.dataset.title !== undefined) {
                link.prepend(link.dataset.title);
            }
            if (link.classList.contains('dropdown-toggle')) {
                link.dataset.class = 'dropdown-toggle';
            }
            link.classList.remove('dropdown-toggle');
            topbarMobileContainer.querySelector('ul').appendChild(item);
        });
    }
};

/**
 * Passe de la topbar mobile à la topbar desktop.
 *
 * @param {string} topbarSelector L'ID de la topbar.
 * @param {string} topbarItemsSelector Le sélecteur CSS des éléments de la topbar.
 * @param {string} mobileClassname Le nom de la classe en mode mobile.
 * @param {string} desktopClassname Le nom de la classe en mode desktop.
 * @param {string} desktopContainerSelector L'ID du container de la topbar en mode desktop.
 */
const topbarDesktop = (
    topbarSelector,
    topbarItemsSelector,
    mobileClassname,
    desktopClassname,
    desktopContainerSelector
) => {
    const topbar = document.querySelector(topbarSelector);

    if (topbar.className === mobileClassname) {
        const topbarItems = document.querySelectorAll(topbarItemsSelector);
        topbarItems.forEach((item) => {
            const link = item.querySelector('a');
            link.classList.add(link.dataset.class);
        });

        topbar.className = desktopClassname;
        document.querySelector(desktopContainerSelector).prepend(topbar);
        topbar.querySelector('ul').prepend(topbarItems[0]);
        topbar.querySelector('ul').append(topbarItems[1]);
    }
};

export { topbarMobile, topbarDesktop };
